<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{trigger: 'click', mode: 'row'}"
      :height="300"
      row-key
      class="sortable-row-demo"
      resizable
      border
      empty-text="暂未添加中转记录"
    >
      <template v-slot:opt1>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:expandContent="{row}">
        <transfer-rule-table :tableData="row.lineList" />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TransferRuleTable from '../transfer-rule-table'
export default {
  components: {
    TransferRuleTable,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      transportModeDictParams: {type: 'transportMode'},
      bizTypeDictParams: {type: 'bizType'},
      tableData: [],
      tableColumns: tableColumns(),
    }
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData) {
          this.load()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getData()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    getData() {
      this.$api
        .masterTransferRuleGetRuleAndDetailApi(this.formData)
        .then((res) => {
          let data = res.body.data
          if (!data && !data.length) {
            this.tableData = []
            return
          }

          data = data.map((rule) => {
            const lineList = rule.lineList
              .sort((a, b) => Number(a.transferSeqno) - Number(b.transferSeqno))
              .map((item) => {
                item.uploadReceiptFlag = 'N'
                return item
              })
            return {...rule, lineList}
          })
          this.tableData = data
        })
    },

    load() {},

    async getRadioRecord() {
      const $table = this.$refs.table
      return await $table.getRadioRecord()
    },
  },
}
</script>
<style lang="scss" scoped>
.sortable-row-demo .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
